// Event / trip packet for `#s09` (FEC-M4-04/05). No events HTTP route exists
// yet, so the hook returns `unavailable` instead of a story packet.
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

export const eventPacketItemSchema = z.object({
  transaction_id: z.string(),
  merchant: z.string(),
  date_label: z.string(),
  account_last4: z.string().nullable(),
  amount: z.string(),
  section: z.enum(['travel', 'lodging', 'meals', 'ground', 'other']),
  pending: z.boolean(),
  receipt: z.enum(['attached', 'missing', 'shared', 'in_app']),
  note: z.string().nullable(),
});

export const eventPacketResultSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('unavailable') }),
  z.object({ status: z.literal('empty') }),
  z.object({
    status: z.literal('ready'),
    event_id: z.string(),
    name: z.string(),
    date_label: z.string(),
    location: z.string().nullable(),
    source_label: z.string().nullable(),
    condition_label: z.string().nullable(),
    currency: z.string(),
    total: z.string(),
    item_count: z.number(),
    charge_count: z.number(),
    pending_count: z.number(),
    items: z.array(eventPacketItemSchema),
    likely_related: z.array(eventPacketItemSchema),
  }),
]);
export type EventPacketResult = z.infer<typeof eventPacketResultSchema>;

export function useEventPacket(eventId: string | undefined) {
  return useQuery<EventPacketResult>({
    queryKey: ['events', eventId],
    enabled: Boolean(eventId),
    queryFn: async () => {
      return { status: 'unavailable' };
    },
  });
}
